<template lang="pug">
  .d-flex.px-3.pb-3
    span.fantasy__block-max_width--8
      v-select(:items="countryItems" v-model="country", :label="labelCountry" background-color="blue-grey lighten-4" dense solo flat outlined hide-details @input="update")
    BaseTextField(rules="required" v-model="text" @input="update", :label="labelName" outlined dense solo flat)
</template>

<script>

  export default {
    name: "LobbyTextField",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Object,
        default: function(){
          return {
            country: '',
            text: '',
          }
        }
      },
      labelName: {
        type: String,
        default: 'Name',
      },
      labelCountry: {
        type: String,
        default: 'Country',
      },
      countryItems: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      country: '',
      text: '',
    }),
    watch: {
      value: function(val){
        this.country = val.country;
        this.text = val.text;
      }
    },
    created(){
      this.country = this.value.country;
      this.text = this.value.text;
    },
    methods:{
      update(){
        this.$emit('input', { country: this.country, text: this.text});
      },
    },
  }
</script>

<style lang="sass">
</style>